import React from "react";
import lashesExtensionImg from "./../../../../Images/EyeLashesInnerPage/Eyelash.png"
const LashesExtensionImg = () => {
  return (
    <div className="headSpaImgContainer">
      <img src={lashesExtensionImg} alt="lashesExtensionImg" />
    </div>
  );
};

export default LashesExtensionImg;
